import { Typography } from '@mui/material';
import DeliveryManagerTable from './AdminDeliveryManagerTable';

const ManageDeliveryManager = () => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Admin Delivery Manager
      </Typography>
      <DeliveryManagerTable />
    </>
  );
};

export default ManageDeliveryManager;
